import type { GitUrl } from "git-url-parse";
import gitUrlParse from "git-url-parse";

/*
 * Resolves the public web URL for a given revision at the target repository URL.
 * Logic in this file is heavily based on: https://github.com/argoproj/argo-cd/blob/master/ui/src/app/shared/components/urls.ts
 */
export function resolveGitRevisionUrl(repositoryUrl: string, revision: string): string | undefined {
    // eslint-disable-next-line @typescript-eslint/init-declarations
    let parsed: gitUrlParse.GitUrl;
    try {
        parsed = gitUrlParse(repositoryUrl);
    } catch {
        return;
    }

    if (!supportedProvider(parsed)) {
        return;
    }

    const revisionIsSha = isSHA(revision);

    let subPath = revisionIsSha ? "commit" : "tree";

    if (parsed.source === "bitbucket.org") {
        // The reason for the condition of 'forPath' is that when we build nested path, we need to use 'src'
        subPath = revisionIsSha ? "commits" : "src";
    } else if (parsed.source === "gitlab.com") {
        subPath = `-/${subPath}`;
    }

    return `${normalizeProtocol(parsed.protocol)}://${parsed.resource}/${parsed.owner}/${parsed.name}/${subPath}/${revision || "HEAD"}`;
}

function supportedProvider(parsed: GitUrl): boolean {
    return parsed.resource.startsWith("github") || ["gitlab.com", "bitbucket.org"].indexOf(parsed.source) >= 0;
}

//if this is a SSH url, then the web url will be https
function normalizeProtocol(protocol: string): string {
    return protocol === "ssh" ? "https" : protocol;
}

//From: https://github.com/argoproj/argo-cd/blob/master/ui/src/app/shared/components/revision.tsx#L25
function isSHA(revision: string) {
    if (revision.startsWith("sha256:")) {
        const hashOnly = revision.replace("sha256:", "");
        return hashOnly.match(/^[a-f0-9]{8,69}$/) !== null;
    }
    // https://stackoverflow.com/questions/468370/a-regex-to-match-a-sha1
    return revision.match(/^[a-f0-9]{5,40}$/) !== null;
}
